export default __webpack_public_path__ + "static/media/fireFN17.f8edbd3a.svg";